import React from "react";
import WhatsAppButton from "@/components/ui/WhatsAppButton";

const FinalCTA: React.FC = () => {
  return (
    <section className="py-12 md:py-24 px-4 md:px-6 bg-gradient-to-b from-primary/10 to-accent">
      <div className="container mx-auto max-w-4xl text-center">
        <div className="space-y-6 md:space-y-8">
          <div>
            <p className="text-xs tracking-widest font-medium uppercase text-primary mb-3">
              CHEGOU A HORA
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 md:mb-6">
              Receba uma avaliação gratuita
            </h2>
          </div>
          
          <div className="space-y-4 text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            <p>
              Entre em contato com a Tax Health e descubra como podemos ajudar a otimizar sua gestão fiscal e aumentar seus lucros.
            </p>
            <p>
              Aproveite nossa experiência e conhecimento especializado para reduzir sua carga tributária de forma legal e eficaz.
            </p>
            <p>
              Clique no botão abaixo para receber uma análise personalizada do seu negócio.
            </p>
          </div>

          <div className="pt-4 md:pt-6">
            <WhatsAppButton 
              text="QUERO UM CONTATO"
              source="final_cta"
              size="lg"
              className="text-base md:text-lg px-8 md:px-12 py-6 md:py-8 h-auto min-h-[52px]"
              showIcon={false}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
